module.exports = "<div class=\"media-browser media-browser-page\">\n\n    <uib-tabset active=\"$tabSetStatus.activeTab\">\n        <uib-tab heading=\"{{ 'Uploaded files' | translate }}\" ng-click=\"$ctrl.setActiveTab(1)\">\n            <cms-media-listing ng-if=\"$ctrl.activeTab == 1\"></cms-media-listing>\n        </uib-tab>\n        <uib-tab heading=\"{{ 'Stock photos' | translate }}\" ng-click=\"$ctrl.setActiveTab(2)\">\n            <cms-unsplash-listing ng-if=\"$ctrl.activeTab == 2\"></cms-unsplash-listing>\n        </uib-tab>\n    </uib-tabset>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/cmsPages/Media/media.html
// module id = 961
// module chunks = 0